export default {
    'memberBenefit.title': 'Member Benefits',
} as Record<string, string>;
